<template>
<div class="container-base"
     v-once>
  <div class="pages page-static">
    <div class="page-static-inner">
      <h1>입력한 정보저장</h1>
      <p>입력한 정보는 단말기의 브라우저(Safari나 Chrome 등) 이력에 저장되어 브라우저를 닫고 새로 사이트에 접속하여도 계속해서 입력 할 수 있습니다.</p>
      <p style="color:red;">공용 PC(PC방이나 학교 등 여러 사람이 이용하는 PC)등에서 이용하실 경우, PC내에 남은 데이터를 다른 사람이 볼 수 있는 가능성이 있습니다.당사는 서비스 이용 후 데이터를 삭제하길 권장하고 있습니다.</p>
      <br>
      <div class="text-right">
        <el-button id="account-delete-account-dialog" type="success"
          @click="$router.push({name: 'accountDelete'});">데이터・계정삭제</el-button>
      </div>
      <br>
      <p>"설정" >> "데이터·계정삭제" >> "브라우저의 데이터를 삭제한다" 에서 브라우저의 이력을 삭제할 수 있습니다.</p>
      <ul>
        <li>・브라우저에서 입력한 내용은 서버에 저장되지 않으므로 본인 이외에는 입력한 내용을 볼 수 없습니다.</li>
        <li>회원가입(Google 계정으로 로그인)을 하면 브라우저의 이력과 별도로 서버에 정보를 저장할 수 있게 됩니다.기기를 변경 하더라고 데이터 가져오기로 입력정보를 계속해서 사용 할 수 있습니다.</li>
      </ul>

      <div class="back-button">
        <router-link to="/">메인으로</router-link>
      </div>
    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () {}
}
</script>
